enum TabNavigationScreens {
  STACK_NAME = 'SA.APP',
  OPPORTUNITIES = 'APP.OPPORTUNITIES',
  CREATE_OPPORTUNITY = 'APP.CREATE_OPPORTUNITY',
  INVENTORY = 'Inventory',
  SETTINGS = 'APP.SETTINGS',
  NOTIFICATION = 'APP.NOTIIFICATION',
}
export default TabNavigationScreens;
